"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleValidator = void 0;
var simple_validators_1 = require("../../types/simple-validators");
var constants_1 = require("../../constants");
var SimpleValidator = /** @class */ (function (_super) {
    __extends(SimpleValidator, _super);
    function SimpleValidator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.minLenghtValidate = function (numberOfChars, errorTextValue) { return function (value) {
            return value && value.length && value.length < numberOfChars
                ? {
                    error: true,
                    errorTextValue: errorTextValue || constants_1.validationErrors.minLenght,
                }
                : { error: false, errorTextValue: '' };
        }; };
        _this.maxLenghtValidate = function (numberOfChars, errorTextValue) { return function (value) {
            return value && value.length && value.length > numberOfChars
                ? {
                    error: true,
                    errorTextValue: errorTextValue || constants_1.validationErrors.maxLenght,
                }
                : { error: false, errorTextValue: '' };
        }; };
        _this.requiredValidator = function (errorTextValue) { return function (value) {
            if (value) {
                // if string is empty
                if (typeof value === 'string' && !Boolean(value.trim())) {
                    return {
                        error: true,
                        errorTextValue: errorTextValue || constants_1.validationErrors.required,
                    };
                }
                // if array in empty
                if (value instanceof Array && value.length === 0) {
                    return {
                        error: true,
                        errorTextValue: errorTextValue || constants_1.validationErrors.required,
                    };
                }
                // success ending
                return { error: false, errorTextValue: '' };
            }
            // if value is not valid
            return {
                error: true,
                errorTextValue: errorTextValue || constants_1.validationErrors.required,
            };
        }; };
        // for backup compatibility
        _this.requiredValidate = _this.requiredValidator;
        _this.rangeValidate = function (_a) {
            var minValue = _a.minValue, maxValue = _a.maxValue, errorTextValue = _a.errorTextValue, isStrict = _a.isStrict;
            return function (value) {
                var numberValue = Number(value);
                var isValid = isStrict
                    ? numberValue > minValue && numberValue < maxValue
                    : numberValue >= minValue && numberValue <= maxValue;
                if (isValid) {
                    return { error: false, errorTextValue: '' };
                }
                return {
                    error: true,
                    errorTextValue: errorTextValue || constants_1.validationErrors.incorrect,
                };
            };
        };
        return _this;
    }
    return SimpleValidator;
}(simple_validators_1.ISimpleValidator));
exports.SimpleValidator = SimpleValidator;
